import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared-common/shared.module';

// components
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { PaginationComponent } from '../../components/pagination/pagination.component';
import { TemplateLoadingComponent } from '../../components/template-loading/template-loading.component';

import { ContentDatePickerComponent } from '../../components/content-date-picker/content-date-picker.component';
import { ChatMessageComponent } from '../../components/chat/chat-message/chat-message.component';
import { ChatMessageButtonIntentComponent } from '../../components/chat/chat-message-button-intent/chat-message-button-intent.component';
import { ChatMessageButtonLinkComponent } from '../../components/chat/chat-message-button-link/chat-message-button-link.component';
import { ChatMessageCarruselComponent } from '../../components/chat/chat-message-carrusel/chat-message-carrusel.component';
import { ChatMessageListOptionsComponent } from '../../components/chat/chat-message-list-options/chat-message-list-options.component';
import { ChatMessageListOrderedComponent } from '../../components/chat/chat-message-list-ordered/chat-message-list-ordered.component';
import { ChatMessageListUnorderedComponent } from '../../components/chat/chat-message-list-unordered/chat-message-list-unordered.component';
import { ChatMessageTextComponent } from '../../components/chat/chat-message-text/chat-message-text.component';
import { ChatMessagesQuickReplyComponent } from '../../components/chat/chat-messages-quick-reply/chat-messages-quick-reply.component';


// Directives
import { AdComponent } from '../../directives/add-components/ad-component';

// Pipe
import { SafeUrlPipe } from '../../pipes/safe-url/safe-url.pipe';
import { DateAgoPipe } from '../../pipes/date-ago/date-ago.pipe';
import { AcronymPipe } from '../../pipes/acronym/acronym.pipe';
import { TranslateStatusPipe } from '../../pipes/translate-status/translate-status.pipe';
import { TranslateErrorCodePipe } from '../../pipes/translate-error-code/translate-error-code.pipe';
// import { TranslateStatusEcommercePipe } from '../../pipes/translate-status-ecommerce/translate-status-ecommerce.pipe';

@NgModule({
    imports: [
        CommonModule,
        SharedModule
    ],
    declarations: [
        BreadcrumbComponent,
        PaginationComponent,
        TemplateLoadingComponent,
        AdComponent,
        SafeUrlPipe,
        DateAgoPipe,
        AcronymPipe,
        TranslateErrorCodePipe,
        TranslateStatusPipe,
        // TranslateStatusEcommercePipe,
        ContentDatePickerComponent,
        ChatMessageComponent,
        ChatMessageButtonIntentComponent,
        ChatMessageButtonLinkComponent,
        ChatMessageCarruselComponent,
        ChatMessageListOptionsComponent,
        ChatMessageListOrderedComponent,
        ChatMessageListUnorderedComponent,
        ChatMessageTextComponent,
        ChatMessagesQuickReplyComponent,
    ],
    exports: [
        BreadcrumbComponent,
        PaginationComponent,
        TemplateLoadingComponent,
        AdComponent,
        SafeUrlPipe,
        DateAgoPipe,
        AcronymPipe,
        TranslateStatusPipe,
        TranslateErrorCodePipe,
        // TranslateStatusEcommercePipe,
        ContentDatePickerComponent,
        ChatMessageComponent,
        ChatMessageButtonIntentComponent,
        ChatMessageButtonLinkComponent,
        ChatMessageCarruselComponent,
        ChatMessageListOptionsComponent,
        ChatMessageListOrderedComponent,
        ChatMessageListUnorderedComponent,
        ChatMessageTextComponent,
        ChatMessagesQuickReplyComponent,
    ]
})
export class SharedComponentsModule { }
